(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/competition/core/assets/javascripts/check-verified-email.js') >= 0) return;  svs.modules.push('/components/competition/core/assets/javascripts/check-verified-email.js'); 'use strict';

svs.competition.core.checkVerifiedEmail = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (typeof options.success !== 'function') {
    options.success = function () {};
  }

  if (typeof options.cancel !== 'function') {
    options.cancel = function () {};
  }

  if (typeof options.message !== 'string') {
    options.message = '';
  }

  svs.core.jupiter.get('/player/customizedsettings', function (data) {
    try {
      if (data) {
        if (data.customizedSettings) {
          var emailStatus, verifiedEmail;

          if (data.customizedSettings.properties && data.customizedSettings.properties.emailStatus) {
            emailStatus = parseInt(data.customizedSettings.properties.emailStatus, 10);
            verifiedEmail = emailStatus === 2 || emailStatus === 4;
          } else {
            svs.syndicate.syndicate_overview.logger.error('Missing properties object from /player/customizedsettings');
            return;
          }

          if (verifiedEmail) {
            options.success();
          } else {
            svs.components.dialog.api.add(new svs.components.dialog.Confirm({
              branding: svs.components.dialog.branding.SPORT,
              icon: 'communication',
              title: "Du beh\xF6ver bekr\xE4fta din e-postadress",
              message: [{
                type: svs.components.dialog.message.TEXT,
                text: options.message
              }],
              actions: [{
                title: 'Avbryt',
                callback: function callback() {
                  svs.components.dialog.api.close();
                  options.cancel();
                }
              }, {
                title: 'Bekräfta',
                callback: function callback() {
                  window.location.href = svs.utils.urlMapping.get('myProfileVerifyEmail');
                }
              }]
            }));
          }
        } else {
          svs.competition.core.logger.error('Missing customizedsettings object from /player/customizedsettings');
          return;
        }
      } else {
        svs.competition.core.logger.error('Empty response object from /player/customizedsettings');
        return;
      }
    } catch (e) {
      svs.competition.core.logger.error('Error parsing server response:', e);
    }
  });
};
 })(window);